module.exports = __webpack_public_path__ + "media/images/squadBet__iconPick-5dde63647d5fa5547383015d04e3f5e1.png";